var map = {
	"./App": [
		38523,
		9,
		[]
	],
	"./App.vue": [
		38523,
		9,
		[]
	],
	"./assets/fonts/PlusJakartaSans-Bold.ttf": [
		64391,
		1,
		[
			4391
		]
	],
	"./assets/fonts/PlusJakartaSans-ExtraBold.ttf": [
		92033,
		1,
		[
			2033
		]
	],
	"./assets/fonts/PlusJakartaSans-ExtraLight.ttf": [
		44992,
		1,
		[
			4992
		]
	],
	"./assets/fonts/PlusJakartaSans-Italic.ttf": [
		89502,
		1,
		[
			9502
		]
	],
	"./assets/fonts/PlusJakartaSans-Light.ttf": [
		33342,
		1,
		[
			3342
		]
	],
	"./assets/fonts/PlusJakartaSans-LightItalic.ttf": [
		18474,
		1,
		[
			8474
		]
	],
	"./assets/fonts/PlusJakartaSans-Medium.ttf": [
		73915,
		1,
		[
			3915
		]
	],
	"./assets/fonts/PlusJakartaSans-MediumItalic.ttf": [
		98115,
		1,
		[
			8115
		]
	],
	"./assets/fonts/PlusJakartaSans-Regular.ttf": [
		7246,
		1,
		[
			7246
		]
	],
	"./assets/fonts/_fonts.scss": [
		99305,
		9,
		[
			9305
		]
	],
	"./assets/icons/arrow.svg": [
		57190,
		1,
		[
			7190
		]
	],
	"./assets/icons/arrow_down.svg": [
		33337,
		1,
		[
			3337
		]
	],
	"./assets/icons/campaigns/ActiveLifestyleCarrefour/receipt.svg": [
		8546,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCarrefour/register.svg": [
		79829,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCarrefour/reward.svg": [
		23595,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCarrefour/select.svg": [
		15282,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCora/receipt.svg": [
		86206,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCora/register.svg": [
		57665,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCora/reward.svg": [
		78783,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleCora/select.svg": [
		38334,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleMega/receipt.svg": [
		54341,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleMega/register.svg": [
		80644,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleMega/reward.svg": [
		34738,
		1,
		[]
	],
	"./assets/icons/campaigns/ActiveLifestyleMega/select.svg": [
		13067,
		1,
		[]
	],
	"./assets/icons/campaigns/AjaxAxion2023/receipt.svg": [
		33526,
		1,
		[]
	],
	"./assets/icons/campaigns/AjaxAxion2023/register.svg": [
		25641,
		1,
		[]
	],
	"./assets/icons/campaigns/AjaxAxion2023/reward.svg": [
		37687,
		1,
		[]
	],
	"./assets/icons/campaigns/AjaxAxion2023/select.svg": [
		85926,
		1,
		[]
	],
	"./assets/icons/campaigns/Auchan2022/receipt.svg": [
		3310,
		1,
		[]
	],
	"./assets/icons/campaigns/Auchan2022/register.svg": [
		30449,
		1,
		[]
	],
	"./assets/icons/campaigns/Auchan2022/reward.svg": [
		80303,
		1,
		[]
	],
	"./assets/icons/campaigns/Auchan2022/select.svg": [
		66158,
		1,
		[]
	],
	"./assets/icons/campaigns/AutumnCleaning2022/receipt.svg": [
		77243,
		1,
		[]
	],
	"./assets/icons/campaigns/AutumnCleaning2022/register.svg": [
		68542,
		1,
		[]
	],
	"./assets/icons/campaigns/AutumnCleaning2022/reward.svg": [
		80488,
		1,
		[]
	],
	"./assets/icons/campaigns/AutumnCleaning2022/select.svg": [
		73709,
		1,
		[]
	],
	"./assets/icons/campaigns/Autumncleaning2023/receipt.svg": [
		29018,
		1,
		[]
	],
	"./assets/icons/campaigns/Autumncleaning2023/register.svg": [
		88573,
		1,
		[]
	],
	"./assets/icons/campaigns/Autumncleaning2023/reward.svg": [
		7331,
		1,
		[]
	],
	"./assets/icons/campaigns/Autumncleaning2023/select.svg": [
		27034,
		1,
		[]
	],
	"./assets/icons/campaigns/Carrefour2022/receipt.svg": [
		41275,
		1,
		[]
	],
	"./assets/icons/campaigns/Carrefour2022/register.svg": [
		19326,
		1,
		[]
	],
	"./assets/icons/campaigns/Carrefour2022/reward.svg": [
		10696,
		1,
		[]
	],
	"./assets/icons/campaigns/Carrefour2022/select.svg": [
		19181,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2024/receipt.svg": [
		29472,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2024/register.svg": [
		61455,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2024/reward.svg": [
		3497,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2024/select.svg": [
		47460,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2025/receipt.svg": [
		70977,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2025/register.svg": [
		49056,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2025/reward.svg": [
		24246,
		1,
		[]
	],
	"./assets/icons/campaigns/CarrefourAniversar2025/select.svg": [
		15015,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateAugust2022/receipt.svg": [
		75646,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateAugust2022/register.svg": [
		56481,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateAugust2022/reward.svg": [
		82143,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateAugust2022/select.svg": [
		79646,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCarrefour21Ani/receipt.svg": [
		79863,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCarrefour21Ani/register.svg": [
		73674,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCarrefour21Ani/reward.svg": [
		50396,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCarrefour21Ani/select.svg": [
		97897,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCharcoal/receipt.svg": [
		84322,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCharcoal/register.svg": [
		46933,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCharcoal/reward.svg": [
		60075,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateCharcoal/select.svg": [
		14418,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateElixirCarrefour2022/receipt.svg": [
		55579,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateElixirCarrefour2022/register.svg": [
		34238,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateElixirCarrefour2022/reward.svg": [
		38984,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateElixirCarrefour2022/select.svg": [
		15853,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateEquityCarrefourJan2022/factura.svg": [
		23700,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateEquityCarrefourJan2022/produse.svg": [
		10256,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateEquityCarrefourJan2022/register.svg": [
		45548,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateEquityCarrefourJan2022/reward.svg": [
		49753,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateIT/receipt.svg": [
		83804,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateIT/register.svg": [
		85771,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateIT/reward.svg": [
		9725,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateIT/select.svg": [
		92944,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateKaufland2025/cashback.svg": [
		35936,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateKaufland2025/product.svg": [
		62113,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateKaufland2025/receipt.svg": [
		98704,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateKaufland2025/register.svg": [
		98527,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLLDP2025/receipt.svg": [
		15242,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLLDP2025/register.svg": [
		26957,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLLDP2025/reward.svg": [
		17139,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLLDP2025/select.svg": [
		86090,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLidl2025/receipt.svg": [
		78867,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLidl2025/register.svg": [
		22054,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLidl2025/reward.svg": [
		33184,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateLidl2025/select.svg": [
		57461,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMax2023/receipt.svg": [
		51874,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMax2023/register.svg": [
		20949,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMax2023/reward.svg": [
		57835,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMax2023/select.svg": [
		49522,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMaxAuchan2023/receipt.svg": [
		75608,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMaxAuchan2023/register.svg": [
		85431,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMaxAuchan2023/reward.svg": [
		66369,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateMaxAuchan2023/select.svg": [
		92780,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHM2024/receipt.svg": [
		38525,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHM2024/register.svg": [
		7756,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHM2024/reward.svg": [
		8106,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHM2024/select.svg": [
		69267,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHMLDP2024/receipt.svg": [
		98061,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHMLDP2024/register.svg": [
		43036,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHMLDP2024/reward.svg": [
		2138,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateOHMLDP2024/select.svg": [
		26755,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmolive2023/receipt.svg": [
		86245,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmolive2023/register.svg": [
		23972,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmolive2023/reward.svg": [
		35570,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmolive2023/select.svg": [
		89003,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmoliveLidl2026/receipt.svg": [
		96090,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmoliveLidl2026/register.svg": [
		18236,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmoliveLidl2026/reward.svg": [
		18618,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgatePalmoliveLidl2026/select.svg": [
		16835,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSeptember2023/receipt.svg": [
		31941,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSeptember2023/register.svg": [
		69796,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSeptember2023/reward.svg": [
		71986,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSeptember2023/select.svg": [
		50315,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummer2023/receipt.svg": [
		50675,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummer2023/register.svg": [
		10310,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummer2023/reward.svg": [
		10400,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummer2023/select.svg": [
		7829,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummerKaufland2023/receipt.svg": [
		57573,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummerKaufland2023/register.svg": [
		49028,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummerKaufland2023/reward.svg": [
		89810,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateSummerKaufland2023/select.svg": [
		43243,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2023/receipt.svg": [
		22698,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2023/register.svg": [
		6701,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2023/reward.svg": [
		35219,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2023/select.svg": [
		69674,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2024/receipt.svg": [
		19633,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2024/register.svg": [
		64336,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2024/reward.svg": [
		30438,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2024/select.svg": [
		55031,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2025/receipt.svg": [
		74736,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2025/register.svg": [
		65663,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2025/reward.svg": [
		75417,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2025/select.svg": [
		55988,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2026/receipt.svg": [
		19439,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2026/register.svg": [
		24114,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2026/reward.svg": [
		33172,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotal2026/select.svg": [
		93233,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalActivePrevention2025/receipt.svg": [
		23082,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalActivePrevention2025/register.svg": [
		66573,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalActivePrevention2025/reward.svg": [
		45875,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalActivePrevention2025/select.svg": [
		59050,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalCarrefour2022/receipt.svg": [
		29814,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalCarrefour2022/register.svg": [
		46217,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalCarrefour2022/reward.svg": [
		10231,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalCarrefour2022/select.svg": [
		76230,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalDM2022/receipt.svg": [
		74906,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalDM2022/register.svg": [
		69341,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalDM2022/reward.svg": [
		48835,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalDM2022/select.svg": [
		38234,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalMegaImage2022/receipt.svg": [
		69386,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalMegaImage2022/register.svg": [
		13005,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalMegaImage2022/reward.svg": [
		42451,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateTotalMegaImage2022/select.svg": [
		11402,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateUltra2023/receipt.svg": [
		91778,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateUltra2023/register.svg": [
		62197,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateUltra2023/reward.svg": [
		36139,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateUltra2023/select.svg": [
		42642,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2024/receipt.svg": [
		78703,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2024/register.svg": [
		88434,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2024/reward.svg": [
		59636,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2024/select.svg": [
		58129,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2025/receipt.svg": [
		66366,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2025/register.svg": [
		1441,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2025/reward.svg": [
		66591,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteMoneyBack2025/select.svg": [
		31902,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2023/receipt.svg": [
		70861,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2023/register.svg": [
		64188,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2023/reward.svg": [
		53594,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2023/select.svg": [
		51811,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2024/receipt.svg": [
		89950,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2024/register.svg": [
		57409,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2024/reward.svg": [
		65919,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhitening2024/select.svg": [
		14878,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningAuchan2022/receipt.svg": [
		85938,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningAuchan2022/register.svg": [
		95461,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningAuchan2022/reward.svg": [
		27739,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningAuchan2022/select.svg": [
		36322,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningCarrefour2022/receipt.svg": [
		28375,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningCarrefour2022/register.svg": [
		35210,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningCarrefour2022/reward.svg": [
		82908,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningCarrefour2022/select.svg": [
		82505,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningSelgros2024/receipt.svg": [
		96561,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningSelgros2024/register.svg": [
		84560,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningSelgros2024/reward.svg": [
		53382,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWhiteningSelgros2024/select.svg": [
		23703,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2024/receipt.svg": [
		9791,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2024/register.svg": [
		74850,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2024/reward.svg": [
		28484,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2024/select.svg": [
		63169,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2025/receipt.svg": [
		32270,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2025/register.svg": [
		2001,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2025/reward.svg": [
		39535,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2025/select.svg": [
		25390,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2026/receipt.svg": [
		91745,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2026/register.svg": [
		608,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2026/reward.svg": [
		44374,
		1,
		[]
	],
	"./assets/icons/campaigns/ColgateWomenDay2026/select.svg": [
		61223,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex-MB2023/receipt.svg": [
		79288,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex-MB2023/register.svg": [
		40407,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex-MB2023/reward.svg": [
		1121,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex-MB2023/select.svg": [
		95724,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex2023/receipt.svg": [
		41556,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex2023/register.svg": [
		18739,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex2023/reward.svg": [
		30325,
		1,
		[]
	],
	"./assets/icons/campaigns/Elmex2023/select.svg": [
		7640,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAuchanFeb2022/receipt.svg": [
		4032,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAuchanFeb2022/register.svg": [
		6639,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAuchanFeb2022/reward.svg": [
		30409,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAuchanFeb2022/select.svg": [
		5764,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAugust2022/receipt.svg": [
		9702,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAugust2022/register.svg": [
		62969,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAugust2022/reward.svg": [
		40231,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexAugust2022/select.svg": [
		83318,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourFeb2022/receipt.svg": [
		49437,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourFeb2022/register.svg": [
		74444,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourFeb2022/reward.svg": [
		71114,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourFeb2022/select.svg": [
		31283,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourJuly2022/receipt.svg": [
		63642,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourJuly2022/register.svg": [
		11197,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourJuly2022/reward.svg": [
		21155,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexCarrefourJuly2022/select.svg": [
		40858,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexIT2023/receipt.svg": [
		79667,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexIT2023/register.svg": [
		10502,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexIT2023/reward.svg": [
		93760,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexIT2023/select.svg": [
		18037,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMegaFeb2022/receipt.svg": [
		41808,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMegaFeb2022/register.svg": [
		34175,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMegaFeb2022/reward.svg": [
		69369,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMegaFeb2022/select.svg": [
		27700,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2024/receipt.svg": [
		8498,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2024/register.svg": [
		3397,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2024/reward.svg": [
		10427,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2024/select.svg": [
		2178,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2025/receipt.svg": [
		17971,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2025/register.svg": [
		646,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2025/reward.svg": [
		31968,
		1,
		[]
	],
	"./assets/icons/campaigns/ElmexMoneyBack2025/select.svg": [
		47797,
		1,
		[]
	],
	"./assets/icons/campaigns/IngrijirePersonalaKaufland2025/receipt.svg": [
		30925,
		1,
		[]
	],
	"./assets/icons/campaigns/IngrijirePersonalaKaufland2025/register.svg": [
		23516,
		1,
		[]
	],
	"./assets/icons/campaigns/IngrijirePersonalaKaufland2025/reward.svg": [
		18810,
		1,
		[]
	],
	"./assets/icons/campaigns/IngrijirePersonalaKaufland2025/select.svg": [
		17027,
		1,
		[]
	],
	"./assets/icons/campaigns/Ladyspeedstick2023/receipt.svg": [
		31834,
		1,
		[]
	],
	"./assets/icons/campaigns/Ladyspeedstick2023/register.svg": [
		85661,
		1,
		[]
	],
	"./assets/icons/campaigns/Ladyspeedstick2023/reward.svg": [
		65187,
		1,
		[]
	],
	"./assets/icons/campaigns/Ladyspeedstick2023/select.svg": [
		68538,
		1,
		[]
	],
	"./assets/icons/campaigns/LidlBeauty2025/receipt.svg": [
		27466,
		1,
		[]
	],
	"./assets/icons/campaigns/LidlBeauty2025/register.svg": [
		70829,
		1,
		[]
	],
	"./assets/icons/campaigns/LidlBeauty2025/reward.svg": [
		23699,
		1,
		[]
	],
	"./assets/icons/campaigns/LidlBeauty2025/select.svg": [
		92650,
		1,
		[]
	],
	"./assets/icons/campaigns/MegaImage2022/receipt.svg": [
		96971,
		1,
		[]
	],
	"./assets/icons/campaigns/MegaImage2022/register.svg": [
		61678,
		1,
		[]
	],
	"./assets/icons/campaigns/MegaImage2022/reward.svg": [
		67704,
		1,
		[]
	],
	"./assets/icons/campaigns/MegaImage2022/select.svg": [
		861,
		1,
		[]
	],
	"./assets/icons/campaigns/Moneyback2022/receipt.svg": [
		23403,
		1,
		[]
	],
	"./assets/icons/campaigns/Moneyback2022/register.svg": [
		70350,
		1,
		[]
	],
	"./assets/icons/campaigns/Moneyback2022/reward.svg": [
		66072,
		1,
		[]
	],
	"./assets/icons/campaigns/Moneyback2022/select.svg": [
		99229,
		1,
		[]
	],
	"./assets/icons/campaigns/Palmolive2023/receipt.svg": [
		91942,
		1,
		[]
	],
	"./assets/icons/campaigns/Palmolive2023/register.svg": [
		84825,
		1,
		[]
	],
	"./assets/icons/campaigns/Palmolive2023/reward.svg": [
		88263,
		1,
		[]
	],
	"./assets/icons/campaigns/Palmolive2023/select.svg": [
		17814,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveCarrefourJune2022/receipt.svg": [
		27450,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveCarrefourJune2022/register.svg": [
		78973,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveCarrefourJune2022/reward.svg": [
		99651,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveCarrefourJune2022/select.svg": [
		94266,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveChristmas2024/receipt.svg": [
		23881,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveChristmas2024/register.svg": [
		26840,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveChristmas2024/reward.svg": [
		98654,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveChristmas2024/select.svg": [
		47071,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveExperentials2023/receipt.svg": [
		47900,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveExperentials2023/register.svg": [
		84139,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveExperentials2023/reward.svg": [
		77373,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveExperentials2023/select.svg": [
		25296,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveLifestyle2024/receipt.svg": [
		17888,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveLifestyle2024/register.svg": [
		623,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveLifestyle2024/reward.svg": [
		90089,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveLifestyle2024/select.svg": [
		17700,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSmoothies2022/receipt.svg": [
		30120,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSmoothies2022/register.svg": [
		87719,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSmoothies2022/reward.svg": [
		20305,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSmoothies2022/select.svg": [
		37020,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSummer2023/receipt.svg": [
		16277,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSummer2023/register.svg": [
		75540,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSummer2023/reward.svg": [
		15426,
		1,
		[]
	],
	"./assets/icons/campaigns/PalmoliveSummer2023/select.svg": [
		64219,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2023/receipt.svg": [
		27613,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2023/register.svg": [
		7116,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2023/reward.svg": [
		80330,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2023/select.svg": [
		40499,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2024/receipt.svg": [
		35118,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2024/register.svg": [
		59121,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2024/reward.svg": [
		77679,
		1,
		[]
	],
	"./assets/icons/campaigns/Protex2024/select.svg": [
		63534,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefour/factura.svg": [
		13877,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefour/register.svg": [
		46696,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefourJan2022/factura.svg": [
		91084,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefourJan2022/produse.svg": [
		84696,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefourJan2022/register.svg": [
		43607,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCarrefourJan2022/reward.svg": [
		63329,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCarrefour2022/receipt.svg": [
		53159,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCarrefour2022/register.svg": [
		4851,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCarrefour2022/reward.svg": [
		6293,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCarrefour2022/select.svg": [
		83608,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCora2022/receipt.svg": [
		68192,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCora2022/register.svg": [
		83663,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCora2022/reward.svg": [
		96201,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalCora2022/select.svg": [
		27460,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalMega2022/receipt.svg": [
		89859,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalMega2022/register.svg": [
		37142,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalMega2022/reward.svg": [
		37584,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexCharcoalMega2022/select.svg": [
		35205,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexHealthProtection2023/receipt.svg": [
		32686,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexHealthProtection2023/register.svg": [
		76529,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexHealthProtection2023/reward.svg": [
		75279,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexHealthProtection2023/select.svg": [
		61134,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerCarrefour2022/receipt.svg": [
		9726,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerCarrefour2022/register.svg": [
		18401,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerCarrefour2022/reward.svg": [
		76895,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerCarrefour2022/select.svg": [
		74398,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerRomania/receipt.svg": [
		22400,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerRomania/register.svg": [
		70415,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerRomania/reward.svg": [
		42249,
		1,
		[]
	],
	"./assets/icons/campaigns/ProtexSummerRomania/select.svg": [
		73508,
		1,
		[]
	],
	"./assets/icons/campaigns/Protexcashback2025/cashback.svg": [
		95509,
		1,
		[]
	],
	"./assets/icons/campaigns/Protexcashback2025/product.svg": [
		79986,
		1,
		[]
	],
	"./assets/icons/campaigns/Protexcashback2025/receipt.svg": [
		67603,
		1,
		[]
	],
	"./assets/icons/campaigns/Protexcashback2025/register.svg": [
		58150,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaning2025/cashback.svg": [
		74123,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaning2025/product.svg": [
		62796,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaning2025/receipt.svg": [
		83617,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaning2025/register.svg": [
		90752,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCarrefour2022/receipt.svg": [
		17489,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCarrefour2022/register.svg": [
		58192,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCarrefour2022/reward.svg": [
		34182,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCarrefour2022/select.svg": [
		4503,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCora2022/receipt.svg": [
		97655,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCora2022/register.svg": [
		70794,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCora2022/reward.svg": [
		97148,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningCora2022/select.svg": [
		91849,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningMega2022/receipt.svg": [
		89672,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningMega2022/register.svg": [
		49383,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningMega2022/reward.svg": [
		29265,
		1,
		[]
	],
	"./assets/icons/campaigns/SpringCleaningMega2022/select.svg": [
		29628,
		1,
		[]
	],
	"./assets/icons/campaigns/Springcleaning2024/receipt.svg": [
		83904,
		1,
		[]
	],
	"./assets/icons/campaigns/Springcleaning2024/register.svg": [
		24431,
		1,
		[]
	],
	"./assets/icons/campaigns/Springcleaning2024/reward.svg": [
		68809,
		1,
		[]
	],
	"./assets/icons/campaigns/Springcleaning2024/select.svg": [
		68,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerExperience2024/receipt.svg": [
		73761,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerExperience2024/register.svg": [
		69056,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerExperience2024/reward.svg": [
		45622,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerExperience2024/select.svg": [
		16807,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerJoy2025/receipt.svg": [
		61378,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerJoy2025/register.svg": [
		23797,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerJoy2025/reward.svg": [
		70443,
		1,
		[]
	],
	"./assets/icons/campaigns/SummerJoy2025/select.svg": [
		24786,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2024/receipt.svg": [
		15038,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2024/register.svg": [
		10593,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2024/reward.svg": [
		99967,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2024/select.svg": [
		48926,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2025/cashback.svg": [
		14657,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2025/product.svg": [
		55254,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2025/receipt.svg": [
		27375,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2025/register.svg": [
		81234,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2026/cashback.svg": [
		51168,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2026/product.svg": [
		95105,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2026/receipt.svg": [
		31696,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2026/register.svg": [
		13759,
		1,
		[]
	],
	"./assets/icons/campaigns/WomenDay2026/reward.svg": [
		97689,
		1,
		[]
	],
	"./assets/icons/close-icon.svg": [
		10801,
		1,
		[
			801
		]
	],
	"./assets/icons/cloud_upload.svg": [
		43510,
		1,
		[
			3510
		]
	],
	"./assets/icons/delete.svg": [
		90930,
		1,
		[]
	],
	"./assets/icons/flags/ro.svg": [
		91226,
		1,
		[]
	],
	"./assets/icons/form/add.svg": [
		36581,
		1,
		[]
	],
	"./assets/icons/form/checked_checkbox.svg": [
		18729,
		1,
		[
			8729
		]
	],
	"./assets/icons/form/checked_radio.svg": [
		271,
		1,
		[
			271
		]
	],
	"./assets/icons/form/down-arrow.svg": [
		1996,
		1,
		[]
	],
	"./assets/icons/form/dropdown.svg": [
		90131,
		1,
		[
			131
		]
	],
	"./assets/icons/form/error.svg": [
		22998,
		1,
		[]
	],
	"./assets/icons/form/information.svg": [
		18198,
		1,
		[]
	],
	"./assets/icons/form/receipt.svg": [
		93104,
		1,
		[
			3104
		]
	],
	"./assets/icons/form/round-checkbox-checked.svg": [
		96906,
		1,
		[
			6906
		]
	],
	"./assets/icons/form/round-checkbox.svg": [
		91230,
		1,
		[
			1230
		]
	],
	"./assets/icons/form/unchecked_checkbox.svg": [
		95352,
		1,
		[
			5352
		]
	],
	"./assets/icons/form/unchecked_checkbox2.svg": [
		50170,
		1,
		[
			170
		]
	],
	"./assets/icons/form/unchecked_radio.svg": [
		21364,
		1,
		[
			1364
		]
	],
	"./assets/icons/h2.svg": [
		33465,
		1,
		[
			3465
		]
	],
	"./assets/icons/minus.svg": [
		48441,
		1,
		[
			8441
		]
	],
	"./assets/icons/mobile-step-arrow.svg": [
		52972,
		1,
		[
			2972
		]
	],
	"./assets/icons/phone.svg": [
		16345,
		1,
		[
			6345
		]
	],
	"./assets/icons/placeholder.svg": [
		15850,
		1,
		[]
	],
	"./assets/icons/plus.svg": [
		24491,
		1,
		[
			4491
		]
	],
	"./assets/icons/risk-icon.svg": [
		54332,
		1,
		[]
	],
	"./assets/icons/search-icon.svg": [
		35691,
		1,
		[
			5691
		]
	],
	"./assets/icons/step3.svg": [
		98760,
		1,
		[
			8760
		]
	],
	"./assets/icons/success.svg": [
		50052,
		1,
		[
			52
		]
	],
	"./assets/icons/tick.svg": [
		16920,
		1,
		[
			6920
		]
	],
	"./assets/icons/upload.svg": [
		50600,
		1,
		[
			600
		]
	],
	"./assets/images/gif/close_campaign.gif": [
		20656,
		1,
		[
			656
		]
	],
	"./assets/images/gif/error_visual.gif": [
		46216,
		1,
		[
			6216
		]
	],
	"./assets/images/js-logo-big.png": [
		91333,
		1,
		[]
	],
	"./assets/images/png/check_1.png": [
		80527,
		1,
		[]
	],
	"./assets/images/png/check_2.png": [
		59060,
		1,
		[]
	],
	"./assets/images/png/check_3.png": [
		96541,
		1,
		[]
	],
	"./assets/images/png/check_4.png": [
		34818,
		1,
		[]
	],
	"./assets/images/png/js-logo-big.png": [
		96453,
		1,
		[]
	],
	"./assets/images/png/receipt.png": [
		38511,
		1,
		[]
	],
	"./assets/images/png/receipt10.png": [
		77444,
		1,
		[]
	],
	"./assets/images/png/receipt11.png": [
		3597,
		1,
		[]
	],
	"./assets/images/png/receipt12.png": [
		12918,
		1,
		[]
	],
	"./assets/images/png/receipt13.png": [
		91007,
		1,
		[]
	],
	"./assets/images/png/receipt14.png": [
		32352,
		1,
		[]
	],
	"./assets/images/png/receipt15.png": [
		87177,
		1,
		[]
	],
	"./assets/images/png/receipt16.png": [
		22034,
		1,
		[]
	],
	"./assets/images/png/receipt17.png": [
		87387,
		1,
		[]
	],
	"./assets/images/png/receipt18.png": [
		91148,
		1,
		[]
	],
	"./assets/images/png/receipt19.png": [
		74037,
		1,
		[]
	],
	"./assets/images/png/receipt2.png": [
		60109,
		1,
		[]
	],
	"./assets/images/png/receipt20.png": [
		48921,
		1,
		[]
	],
	"./assets/images/png/receipt21.png": [
		42672,
		1,
		[]
	],
	"./assets/images/png/receipt22.png": [
		13963,
		1,
		[]
	],
	"./assets/images/png/receipt23.png": [
		92834,
		1,
		[]
	],
	"./assets/images/png/receipt24.png": [
		97085,
		1,
		[]
	],
	"./assets/images/png/receipt25.png": [
		64052,
		1,
		[]
	],
	"./assets/images/png/receipt26.png": [
		38543,
		1,
		[]
	],
	"./assets/images/png/receipt27.png": [
		99526,
		1,
		[]
	],
	"./assets/images/png/receipt28.png": [
		34721,
		1,
		[]
	],
	"./assets/images/png/receipt29.png": [
		13592,
		1,
		[]
	],
	"./assets/images/png/receipt3.png": [
		20164,
		1,
		[]
	],
	"./assets/images/png/receipt4.png": [
		1819,
		1,
		[]
	],
	"./assets/images/png/receipt5.png": [
		3954,
		1,
		[]
	],
	"./assets/images/png/receipt6.png": [
		94665,
		1,
		[]
	],
	"./assets/images/png/receipt7.png": [
		23488,
		1,
		[]
	],
	"./assets/images/png/receipt8.png": [
		84071,
		1,
		[]
	],
	"./assets/images/png/receipt8.svg": [
		26635,
		1,
		[
			6635
		]
	],
	"./assets/images/png/receipt9.png": [
		65758,
		1,
		[]
	],
	"./assets/images/svg/checkMark.svg": [
		59573,
		1,
		[]
	],
	"./assets/images/svg/cross_red.svg": [
		3814,
		1,
		[]
	],
	"./assets/images/svg/receipt-lightblue.svg": [
		92293,
		1,
		[]
	],
	"./assets/images/svg/receipt-red.svg": [
		14728,
		1,
		[]
	],
	"./assets/images/svg/receipt29.svg": [
		58597,
		1,
		[]
	],
	"./assets/images/svg/receipt30.svg": [
		91823,
		1,
		[]
	],
	"./assets/images/svg/receipt31.svg": [
		71774,
		1,
		[]
	],
	"./assets/images/svg/receipt32.svg": [
		18045,
		1,
		[]
	],
	"./assets/images/svg/receipt33.svg": [
		89500,
		1,
		[]
	],
	"./assets/images/svg/receipt34.svg": [
		87427,
		1,
		[]
	],
	"./assets/images/svg/receipt35.svg": [
		84114,
		1,
		[]
	],
	"./assets/images/svg/receipt36.svg": [
		89153,
		1,
		[]
	],
	"./assets/images/svg/receipt37.svg": [
		98032,
		1,
		[]
	],
	"./assets/images/svg/receipt38.svg": [
		78599,
		1,
		[]
	],
	"./assets/images/svg/receipt39.svg": [
		31734,
		1,
		[]
	],
	"./assets/images/svg/receipt8.svg": [
		71646,
		1,
		[]
	],
	"./assets/images/svg/upload.svg": [
		11785,
		1,
		[]
	],
	"./assets/styles/_application.scss": [
		52083,
		9,
		[
			2083
		]
	],
	"./assets/styles/receipt-editor.css": [
		6616,
		9,
		[
			6616
		]
	],
	"./components/component-renderer": [
		39859,
		9,
		[]
	],
	"./components/component-renderer.vue": [
		39859,
		9,
		[]
	],
	"./components/modal": [
		63212,
		9,
		[
			3212
		]
	],
	"./components/modal.vue": [
		63212,
		9,
		[
			3212
		]
	],
	"./components/page": [
		33113,
		9,
		[
			3113
		]
	],
	"./components/page.vue": [
		33113,
		9,
		[
			3113
		]
	],
	"./components/product-item": [
		87683,
		9,
		[
			7683
		]
	],
	"./components/product-item.vue": [
		87683,
		9,
		[
			7683
		]
	],
	"./components/receipt-editor": [
		47675,
		9,
		[]
	],
	"./components/receipt-editor/": [
		47675,
		9,
		[]
	],
	"./components/receipt-editor/Cropper": [
		26028,
		9,
		[]
	],
	"./components/receipt-editor/Cropper.vue": [
		26028,
		9,
		[]
	],
	"./components/receipt-editor/Erazer": [
		37046,
		9,
		[]
	],
	"./components/receipt-editor/Erazer.vue": [
		37046,
		9,
		[]
	],
	"./components/receipt-editor/FileInput": [
		11194,
		9,
		[]
	],
	"./components/receipt-editor/FileInput.vue": [
		11194,
		9,
		[]
	],
	"./components/receipt-editor/ImageDrawer": [
		80076,
		9,
		[]
	],
	"./components/receipt-editor/ImageDrawer.vue": [
		80076,
		9,
		[]
	],
	"./components/receipt-editor/ReceiptScanLoader": [
		98265,
		9,
		[]
	],
	"./components/receipt-editor/ReceiptScanLoader.vue": [
		98265,
		9,
		[]
	],
	"./components/receipt-editor/ReceiptScanner": [
		49120,
		9,
		[]
	],
	"./components/receipt-editor/ReceiptScanner.vue": [
		49120,
		9,
		[]
	],
	"./components/receipt-editor/Zoomer": [
		41357,
		9,
		[]
	],
	"./components/receipt-editor/Zoomer.vue": [
		41357,
		9,
		[]
	],
	"./components/receipt-editor/index": [
		47675,
		9,
		[]
	],
	"./components/receipt-editor/index.js": [
		47675,
		9,
		[]
	],
	"./components/renderers": [
		287,
		9,
		[]
	],
	"./components/renderers/": [
		287,
		9,
		[]
	],
	"./components/renderers/FormWizard": [
		78501,
		9,
		[]
	],
	"./components/renderers/FormWizard/": [
		78501,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/FormWizard": [
		73193,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/FormWizard.vue": [
		73193,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/TabContent": [
		54036,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/TabContent.vue": [
		54036,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/WizardButton": [
		6224,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/WizardButton.vue": [
		6224,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/WizardStep": [
		19011,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/WizardStep.vue": [
		19011,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/helpers": [
		40319,
		9,
		[]
	],
	"./components/renderers/FormWizard/components/helpers.js": [
		40319,
		9,
		[]
	],
	"./components/renderers/FormWizard/index": [
		78501,
		9,
		[]
	],
	"./components/renderers/FormWizard/index.js": [
		78501,
		9,
		[]
	],
	"./components/renderers/ProductSelection": [
		26320,
		9,
		[]
	],
	"./components/renderers/ProductSelection/": [
		26320,
		9,
		[]
	],
	"./components/renderers/ProductSelection/index": [
		26320,
		9,
		[]
	],
	"./components/renderers/ProductSelection/index.vue": [
		26320,
		9,
		[]
	],
	"./components/renderers/ProductSelection/product": [
		11631,
		9,
		[]
	],
	"./components/renderers/ProductSelection/product.vue": [
		11631,
		9,
		[]
	],
	"./components/renderers/SmsVerification/sms-verification": [
		71884,
		9,
		[]
	],
	"./components/renderers/SmsVerification/sms-verification.vue": [
		71884,
		9,
		[]
	],
	"./components/renderers/alert": [
		52811,
		9,
		[]
	],
	"./components/renderers/alert.vue": [
		52811,
		9,
		[]
	],
	"./components/renderers/anchor": [
		38199,
		9,
		[]
	],
	"./components/renderers/anchor.vue": [
		38199,
		9,
		[]
	],
	"./components/renderers/background": [
		41660,
		9,
		[]
	],
	"./components/renderers/background.vue": [
		41660,
		9,
		[]
	],
	"./components/renderers/bucket": [
		59517,
		9,
		[]
	],
	"./components/renderers/bucket.vue": [
		59517,
		9,
		[]
	],
	"./components/renderers/button-component": [
		63077,
		9,
		[]
	],
	"./components/renderers/button-component.vue": [
		63077,
		9,
		[]
	],
	"./components/renderers/card": [
		34757,
		9,
		[]
	],
	"./components/renderers/card.vue": [
		34757,
		9,
		[]
	],
	"./components/renderers/checkReceiptToken": [
		66961,
		9,
		[]
	],
	"./components/renderers/checkReceiptToken.vue": [
		66961,
		9,
		[]
	],
	"./components/renderers/checkbox": [
		64835,
		9,
		[]
	],
	"./components/renderers/checkbox.vue": [
		64835,
		9,
		[]
	],
	"./components/renderers/container": [
		14189,
		9,
		[]
	],
	"./components/renderers/container.vue": [
		14189,
		9,
		[]
	],
	"./components/renderers/datalayer-event": [
		95666,
		9,
		[]
	],
	"./components/renderers/datalayer-event.vue": [
		95666,
		9,
		[]
	],
	"./components/renderers/date-input": [
		59230,
		9,
		[]
	],
	"./components/renderers/date-input.vue": [
		59230,
		9,
		[]
	],
	"./components/renderers/docs-embed": [
		43083,
		9,
		[]
	],
	"./components/renderers/docs-embed.vue": [
		43083,
		9,
		[]
	],
	"./components/renderers/doi": [
		87967,
		9,
		[]
	],
	"./components/renderers/doi.vue": [
		87967,
		9,
		[]
	],
	"./components/renderers/empty-bucket": [
		99148,
		9,
		[]
	],
	"./components/renderers/empty-bucket.vue": [
		99148,
		9,
		[]
	],
	"./components/renderers/error-page": [
		25444,
		9,
		[]
	],
	"./components/renderers/error-page.vue": [
		25444,
		9,
		[]
	],
	"./components/renderers/expired-page": [
		65616,
		9,
		[]
	],
	"./components/renderers/expired-page.vue": [
		65616,
		9,
		[]
	],
	"./components/renderers/flex-container": [
		56273,
		9,
		[]
	],
	"./components/renderers/flex-container.vue": [
		56273,
		9,
		[]
	],
	"./components/renderers/footer-component": [
		64573,
		9,
		[]
	],
	"./components/renderers/footer-component.vue": [
		64573,
		9,
		[]
	],
	"./components/renderers/form-component": [
		31883,
		9,
		[]
	],
	"./components/renderers/form-component.vue": [
		31883,
		9,
		[]
	],
	"./components/renderers/google-recaptcha-v2": [
		60972,
		9,
		[]
	],
	"./components/renderers/google-recaptcha-v2.vue": [
		60972,
		9,
		[]
	],
	"./components/renderers/gtin-component": [
		19270,
		9,
		[]
	],
	"./components/renderers/gtin-component.vue": [
		19270,
		9,
		[]
	],
	"./components/renderers/heading": [
		5145,
		9,
		[]
	],
	"./components/renderers/heading.vue": [
		5145,
		9,
		[]
	],
	"./components/renderers/iban-reupload": [
		45427,
		9,
		[]
	],
	"./components/renderers/iban-reupload.vue": [
		45427,
		9,
		[]
	],
	"./components/renderers/index": [
		287,
		9,
		[]
	],
	"./components/renderers/index.js": [
		287,
		9,
		[]
	],
	"./components/renderers/inject-tag": [
		60960,
		9,
		[]
	],
	"./components/renderers/inject-tag.vue": [
		60960,
		9,
		[]
	],
	"./components/renderers/key-visual": [
		23992,
		9,
		[]
	],
	"./components/renderers/key-visual.vue": [
		23992,
		9,
		[]
	],
	"./components/renderers/mfa-modal": [
		2311,
		9,
		[]
	],
	"./components/renderers/mfa-modal.vue": [
		2311,
		9,
		[]
	],
	"./components/renderers/multi-campaign": [
		12184,
		9,
		[]
	],
	"./components/renderers/multi-campaign.vue": [
		12184,
		9,
		[]
	],
	"./components/renderers/navbar": [
		16077,
		9,
		[]
	],
	"./components/renderers/navbar.vue": [
		16077,
		9,
		[]
	],
	"./components/renderers/paragraph": [
		90697,
		9,
		[]
	],
	"./components/renderers/paragraph.vue": [
		90697,
		9,
		[]
	],
	"./components/renderers/participa": [
		89331,
		9,
		[]
	],
	"./components/renderers/participa.vue": [
		89331,
		9,
		[]
	],
	"./components/renderers/participations": [
		24321,
		9,
		[]
	],
	"./components/renderers/participations.vue": [
		24321,
		9,
		[]
	],
	"./components/renderers/pdf-viewer": [
		75573,
		9,
		[]
	],
	"./components/renderers/pdf-viewer.vue": [
		75573,
		9,
		[]
	],
	"./components/renderers/product-upload": [
		20541,
		9,
		[]
	],
	"./components/renderers/product-upload.vue": [
		20541,
		9,
		[]
	],
	"./components/renderers/query-string-to-state": [
		40774,
		9,
		[]
	],
	"./components/renderers/query-string-to-state.vue": [
		40774,
		9,
		[]
	],
	"./components/renderers/question": [
		4909,
		9,
		[]
	],
	"./components/renderers/question.vue": [
		4909,
		9,
		[]
	],
	"./components/renderers/radio-input": [
		25152,
		9,
		[]
	],
	"./components/renderers/radio-input.vue": [
		25152,
		9,
		[]
	],
	"./components/renderers/receipt-image-information": [
		44184,
		9,
		[]
	],
	"./components/renderers/receipt-image-information.vue": [
		44184,
		9,
		[]
	],
	"./components/renderers/receipt-information": [
		58000,
		9,
		[]
	],
	"./components/renderers/receipt-information.vue": [
		58000,
		9,
		[]
	],
	"./components/renderers/receipt-processor": [
		54150,
		9,
		[]
	],
	"./components/renderers/receipt-processor.vue": [
		54150,
		9,
		[]
	],
	"./components/renderers/reclaim-bucket": [
		71759,
		9,
		[]
	],
	"./components/renderers/reclaim-bucket.vue": [
		71759,
		9,
		[]
	],
	"./components/renderers/refresh-token": [
		18235,
		9,
		[]
	],
	"./components/renderers/refresh-token.vue": [
		18235,
		9,
		[]
	],
	"./components/renderers/segmenta-cookieHandler": [
		1009,
		9,
		[]
	],
	"./components/renderers/segmenta-cookieHandler.vue": [
		1009,
		9,
		[]
	],
	"./components/renderers/select-input": [
		28686,
		9,
		[]
	],
	"./components/renderers/select-input-city": [
		39430,
		9,
		[]
	],
	"./components/renderers/select-input-city.vue": [
		39430,
		9,
		[]
	],
	"./components/renderers/select-input-county": [
		38407,
		9,
		[]
	],
	"./components/renderers/select-input-county.vue": [
		38407,
		9,
		[]
	],
	"./components/renderers/select-input.vue": [
		28686,
		9,
		[]
	],
	"./components/renderers/square-image": [
		71726,
		9,
		[]
	],
	"./components/renderers/square-image.vue": [
		71726,
		9,
		[]
	],
	"./components/renderers/step-card": [
		44586,
		9,
		[]
	],
	"./components/renderers/step-card.vue": [
		44586,
		9,
		[]
	],
	"./components/renderers/step-counter": [
		70763,
		9,
		[]
	],
	"./components/renderers/step-counter.vue": [
		70763,
		9,
		[]
	],
	"./components/renderers/steps-component": [
		86948,
		9,
		[]
	],
	"./components/renderers/steps-component.vue": [
		86948,
		9,
		[]
	],
	"./components/renderers/steps-horizontal": [
		92423,
		9,
		[]
	],
	"./components/renderers/steps-horizontal.vue": [
		92423,
		9,
		[]
	],
	"./components/renderers/text-area": [
		29377,
		9,
		[]
	],
	"./components/renderers/text-area.vue": [
		29377,
		9,
		[]
	],
	"./components/renderers/text-input": [
		83111,
		9,
		[]
	],
	"./components/renderers/text-input.vue": [
		83111,
		9,
		[]
	],
	"./components/renderers/text-list": [
		49617,
		9,
		[]
	],
	"./components/renderers/text-list.vue": [
		49617,
		9,
		[]
	],
	"./components/renderers/thank-you": [
		48503,
		9,
		[]
	],
	"./components/renderers/thank-you-winner": [
		47166,
		9,
		[]
	],
	"./components/renderers/thank-you-winner.vue": [
		47166,
		9,
		[]
	],
	"./components/renderers/thank-you.vue": [
		48503,
		9,
		[]
	],
	"./components/section": [
		93476,
		9,
		[
			3476
		]
	],
	"./components/section.vue": [
		93476,
		9,
		[
			3476
		]
	],
	"./data/actions": [
		91635,
		9,
		[
			1635
		]
	],
	"./data/actions.js": [
		91635,
		9,
		[
			1635
		]
	],
	"./data/form-data": [
		28713,
		9,
		[
			8713
		]
	],
	"./data/form-data.js": [
		28713,
		9,
		[
			8713
		]
	],
	"./data/page-data": [
		94018,
		9,
		[
			4018
		]
	],
	"./data/page-data.js": [
		94018,
		9,
		[
			4018
		]
	],
	"./data/page-data_1": [
		7370,
		9,
		[
			7370
		]
	],
	"./data/page-data_1.js": [
		7370,
		9,
		[
			7370
		]
	],
	"./data/products": [
		28710,
		9,
		[
			8710
		]
	],
	"./data/products.js": [
		28710,
		9,
		[
			8710
		]
	],
	"./helpers/common-components": [
		65033,
		9,
		[]
	],
	"./helpers/common-components.js": [
		65033,
		9,
		[]
	],
	"./i18n": [
		32244,
		9,
		[]
	],
	"./i18n/": [
		32244,
		9,
		[]
	],
	"./i18n/index": [
		32244,
		9,
		[]
	],
	"./i18n/index.js": [
		32244,
		9,
		[]
	],
	"./i18n/languages/en": [
		48081,
		9,
		[]
	],
	"./i18n/languages/en.js": [
		48081,
		9,
		[]
	],
	"./i18n/languages/ro": [
		18429,
		9,
		[]
	],
	"./i18n/languages/ro.js": [
		18429,
		9,
		[]
	],
	"./main": [
		58790,
		9,
		[]
	],
	"./main.js": [
		58790,
		9,
		[]
	],
	"./mixins": [
		22474,
		9,
		[]
	],
	"./mixins/": [
		22474,
		9,
		[]
	],
	"./mixins/componentActions": [
		66574,
		9,
		[]
	],
	"./mixins/componentActions.js": [
		66574,
		9,
		[]
	],
	"./mixins/cssVars": [
		67215,
		9,
		[]
	],
	"./mixins/cssVars.js": [
		67215,
		9,
		[]
	],
	"./mixins/generateUID": [
		38785,
		9,
		[]
	],
	"./mixins/generateUID.js": [
		38785,
		9,
		[]
	],
	"./mixins/index": [
		22474,
		9,
		[]
	],
	"./mixins/index.js": [
		22474,
		9,
		[]
	],
	"./mixins/scrollTo": [
		65500,
		9,
		[]
	],
	"./mixins/scrollTo.js": [
		65500,
		9,
		[]
	],
	"./mixins/showModal": [
		15428,
		9,
		[]
	],
	"./mixins/showModal.js": [
		15428,
		9,
		[]
	],
	"./mixins/updateProperty": [
		64276,
		9,
		[]
	],
	"./mixins/updateProperty.js": [
		64276,
		9,
		[]
	],
	"./router": [
		58197,
		9,
		[]
	],
	"./router/": [
		58197,
		9,
		[]
	],
	"./router/index": [
		58197,
		9,
		[]
	],
	"./router/index.js": [
		58197,
		9,
		[]
	],
	"./store": [
		41153,
		9,
		[]
	],
	"./store/": [
		41153,
		9,
		[]
	],
	"./store/actions": [
		30370,
		9,
		[]
	],
	"./store/actions.js": [
		30370,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleCarrefour": [
		76653,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleCarrefour.js": [
		76653,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleCora": [
		70595,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleCora.js": [
		70595,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleMega": [
		46662,
		9,
		[]
	],
	"./store/campaigns/ActiveLifestyleMega.js": [
		46662,
		9,
		[]
	],
	"./store/campaigns/AjaxAxion2023": [
		3615,
		9,
		[]
	],
	"./store/campaigns/AjaxAxion2023.js": [
		3615,
		9,
		[]
	],
	"./store/campaigns/Auchan2022": [
		72445,
		9,
		[]
	],
	"./store/campaigns/Auchan2022.js": [
		72445,
		9,
		[]
	],
	"./store/campaigns/AutumnCleaning2022": [
		6342,
		9,
		[]
	],
	"./store/campaigns/AutumnCleaning2022.js": [
		6342,
		9,
		[]
	],
	"./store/campaigns/Autumncleaning2023": [
		51269,
		9,
		[]
	],
	"./store/campaigns/Autumncleaning2023.js": [
		51269,
		9,
		[]
	],
	"./store/campaigns/Carrefour2022": [
		85852,
		9,
		[]
	],
	"./store/campaigns/Carrefour2022.js": [
		85852,
		9,
		[]
	],
	"./store/campaigns/CarrefourAniversar2024": [
		60367,
		9,
		[]
	],
	"./store/campaigns/CarrefourAniversar2024.js": [
		60367,
		9,
		[]
	],
	"./store/campaigns/CarrefourAniversar2025": [
		26008,
		9,
		[]
	],
	"./store/campaigns/CarrefourAniversar2025.js": [
		26008,
		9,
		[]
	],
	"./store/campaigns/ColgateAugust2022": [
		71887,
		9,
		[]
	],
	"./store/campaigns/ColgateAugust2022.js": [
		71887,
		9,
		[]
	],
	"./store/campaigns/ColgateCarrefour21Ani": [
		7500,
		9,
		[]
	],
	"./store/campaigns/ColgateCarrefour21Ani.js": [
		7500,
		9,
		[]
	],
	"./store/campaigns/ColgateCharcoal": [
		51299,
		9,
		[]
	],
	"./store/campaigns/ColgateCharcoal.js": [
		51299,
		9,
		[]
	],
	"./store/campaigns/ColgateElixirCarrefour2022": [
		9414,
		9,
		[]
	],
	"./store/campaigns/ColgateElixirCarrefour2022.js": [
		9414,
		9,
		[]
	],
	"./store/campaigns/ColgateEquityCarrefourJan2022": [
		465,
		9,
		[]
	],
	"./store/campaigns/ColgateEquityCarrefourJan2022.js": [
		465,
		9,
		[]
	],
	"./store/campaigns/ColgateIT": [
		87661,
		9,
		[]
	],
	"./store/campaigns/ColgateIT.js": [
		87661,
		9,
		[]
	],
	"./store/campaigns/ColgateKaufland2025": [
		34033,
		9,
		[]
	],
	"./store/campaigns/ColgateKaufland2025.js": [
		34033,
		9,
		[]
	],
	"./store/campaigns/ColgateLLDP2025": [
		86835,
		9,
		[]
	],
	"./store/campaigns/ColgateLLDP2025.js": [
		86835,
		9,
		[]
	],
	"./store/campaigns/ColgateLidl2025": [
		4572,
		9,
		[]
	],
	"./store/campaigns/ColgateLidl2025.js": [
		4572,
		9,
		[]
	],
	"./store/campaigns/ColgateMax2023": [
		56781,
		9,
		[]
	],
	"./store/campaigns/ColgateMax2023.js": [
		56781,
		9,
		[]
	],
	"./store/campaigns/ColgateMaxAuchan2023": [
		49135,
		9,
		[]
	],
	"./store/campaigns/ColgateMaxAuchan2023.js": [
		49135,
		9,
		[]
	],
	"./store/campaigns/ColgateOHM2024": [
		67592,
		9,
		[]
	],
	"./store/campaigns/ColgateOHM2024.js": [
		67592,
		9,
		[]
	],
	"./store/campaigns/ColgateOHMLDP2024": [
		64538,
		9,
		[]
	],
	"./store/campaigns/ColgateOHMLDP2024.js": [
		64538,
		9,
		[]
	],
	"./store/campaigns/ColgatePalmolive2023": [
		84612,
		9,
		[]
	],
	"./store/campaigns/ColgatePalmolive2023.js": [
		84612,
		9,
		[]
	],
	"./store/campaigns/ColgatePalmoliveLidl2026": [
		22124,
		9,
		[]
	],
	"./store/campaigns/ColgatePalmoliveLidl2026.js": [
		22124,
		9,
		[]
	],
	"./store/campaigns/ColgateSeptember2023": [
		11180,
		9,
		[]
	],
	"./store/campaigns/ColgateSeptember2023.js": [
		11180,
		9,
		[]
	],
	"./store/campaigns/ColgateSummer2023": [
		89000,
		9,
		[]
	],
	"./store/campaigns/ColgateSummer2023.js": [
		89000,
		9,
		[]
	],
	"./store/campaigns/ColgateSummerKaufland2023": [
		97186,
		9,
		[]
	],
	"./store/campaigns/ColgateSummerKaufland2023.js": [
		97186,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2023": [
		94821,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2023.js": [
		94821,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2024": [
		12144,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2024.js": [
		12144,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2025": [
		19015,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2025.js": [
		19015,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2026": [
		91994,
		9,
		[]
	],
	"./store/campaigns/ColgateTotal2026.js": [
		91994,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalActivePrevention2025": [
		51573,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalActivePrevention2025.js": [
		51573,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalCarrefour2022": [
		80535,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalCarrefour2022.js": [
		80535,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalDM2022": [
		18573,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalDM2022.js": [
		18573,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalFraud2024": [
		61984,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalFraud2024.js": [
		61984,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalMegaImage2022": [
		67223,
		9,
		[]
	],
	"./store/campaigns/ColgateTotalMegaImage2022.js": [
		67223,
		9,
		[]
	],
	"./store/campaigns/ColgateUltra2023": [
		58477,
		9,
		[]
	],
	"./store/campaigns/ColgateUltra2023.js": [
		58477,
		9,
		[]
	],
	"./store/campaigns/ColgateWhite2025": [
		51964,
		9,
		[]
	],
	"./store/campaigns/ColgateWhite2025.js": [
		51964,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteMoneyBack2024": [
		9968,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteMoneyBack2024.js": [
		9968,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteMoneyBack2025": [
		34119,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteMoneyBack2025.js": [
		34119,
		9,
		[]
	],
	"./store/campaigns/ColgateWhitening2023": [
		95320,
		9,
		[]
	],
	"./store/campaigns/ColgateWhitening2023.js": [
		95320,
		9,
		[]
	],
	"./store/campaigns/ColgateWhitening2024": [
		87757,
		9,
		[]
	],
	"./store/campaigns/ColgateWhitening2024.js": [
		87757,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningAuchan2022": [
		38841,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningAuchan2022.js": [
		38841,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningCarrefour2022": [
		74320,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningCarrefour2022.js": [
		74320,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningSelgros2024": [
		46450,
		9,
		[]
	],
	"./store/campaigns/ColgateWhiteningSelgros2024.js": [
		46450,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2024": [
		60056,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2024.js": [
		60056,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2025": [
		6863,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2025.js": [
		6863,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2026": [
		32674,
		9,
		[]
	],
	"./store/campaigns/ColgateWomenDay2026.js": [
		32674,
		9,
		[]
	],
	"./store/campaigns/Elmex-MB2023": [
		38887,
		9,
		[]
	],
	"./store/campaigns/Elmex-MB2023.js": [
		38887,
		9,
		[]
	],
	"./store/campaigns/Elmex2023": [
		34021,
		9,
		[]
	],
	"./store/campaigns/Elmex2023.js": [
		34021,
		9,
		[]
	],
	"./store/campaigns/ElmexAuchanFeb2022": [
		6103,
		9,
		[]
	],
	"./store/campaigns/ElmexAuchanFeb2022.js": [
		6103,
		9,
		[]
	],
	"./store/campaigns/ElmexAugust2022": [
		15423,
		9,
		[]
	],
	"./store/campaigns/ElmexAugust2022.js": [
		15423,
		9,
		[]
	],
	"./store/campaigns/ElmexCarrefourFeb2022": [
		30046,
		9,
		[]
	],
	"./store/campaigns/ElmexCarrefourFeb2022.js": [
		30046,
		9,
		[]
	],
	"./store/campaigns/ElmexCarrefourJuly2022": [
		2173,
		9,
		[]
	],
	"./store/campaigns/ElmexCarrefourJuly2022.js": [
		2173,
		9,
		[]
	],
	"./store/campaigns/ElmexIT2023": [
		75332,
		9,
		[]
	],
	"./store/campaigns/ElmexIT2023.js": [
		75332,
		9,
		[]
	],
	"./store/campaigns/ElmexMegaFeb2022": [
		81663,
		9,
		[]
	],
	"./store/campaigns/ElmexMegaFeb2022.js": [
		81663,
		9,
		[]
	],
	"./store/campaigns/ElmexMoneyBack2024": [
		47841,
		7,
		[]
	],
	"./store/campaigns/ElmexMoneyBack2024.js": [
		47841,
		7,
		[]
	],
	"./store/campaigns/ElmexMoneyBack2025": [
		28114,
		9,
		[]
	],
	"./store/campaigns/ElmexMoneyBack2025.js": [
		28114,
		9,
		[]
	],
	"./store/campaigns/IngrijirePersonalaKaufland2025": [
		74976,
		9,
		[]
	],
	"./store/campaigns/IngrijirePersonalaKaufland2025.js": [
		74976,
		9,
		[]
	],
	"./store/campaigns/Ladyspeedstick2023": [
		54029,
		9,
		[]
	],
	"./store/campaigns/Ladyspeedstick2023.js": [
		54029,
		9,
		[]
	],
	"./store/campaigns/LidlBeauty2025": [
		14569,
		9,
		[]
	],
	"./store/campaigns/LidlBeauty2025.js": [
		14569,
		9,
		[]
	],
	"./store/campaigns/MegaImage2022": [
		99720,
		9,
		[]
	],
	"./store/campaigns/MegaImage2022.js": [
		99720,
		9,
		[]
	],
	"./store/campaigns/Moneyback2022": [
		24480,
		9,
		[]
	],
	"./store/campaigns/Moneyback2022.js": [
		24480,
		9,
		[]
	],
	"./store/campaigns/Palmolive2023": [
		14707,
		9,
		[]
	],
	"./store/campaigns/Palmolive2023.js": [
		14707,
		9,
		[]
	],
	"./store/campaigns/PalmoliveCarrefourJune2022": [
		98161,
		9,
		[]
	],
	"./store/campaigns/PalmoliveCarrefourJune2022.js": [
		98161,
		9,
		[]
	],
	"./store/campaigns/PalmoliveChristmas2024": [
		37236,
		9,
		[]
	],
	"./store/campaigns/PalmoliveChristmas2024.js": [
		37236,
		9,
		[]
	],
	"./store/campaigns/PalmoliveExperentials2023": [
		9825,
		9,
		[]
	],
	"./store/campaigns/PalmoliveExperentials2023.js": [
		9825,
		9,
		[]
	],
	"./store/campaigns/PalmoliveLifestyle2024": [
		15491,
		9,
		[]
	],
	"./store/campaigns/PalmoliveLifestyle2024.js": [
		15491,
		9,
		[]
	],
	"./store/campaigns/PalmoliveSmoothies2022": [
		2723,
		9,
		[]
	],
	"./store/campaigns/PalmoliveSmoothies2022.js": [
		2723,
		9,
		[]
	],
	"./store/campaigns/PalmoliveSummer2023": [
		82430,
		9,
		[]
	],
	"./store/campaigns/PalmoliveSummer2023.js": [
		82430,
		9,
		[]
	],
	"./store/campaigns/Protex2023": [
		18380,
		9,
		[]
	],
	"./store/campaigns/Protex2023.js": [
		18380,
		9,
		[]
	],
	"./store/campaigns/Protex2024": [
		53913,
		9,
		[]
	],
	"./store/campaigns/Protex2024.js": [
		53913,
		9,
		[]
	],
	"./store/campaigns/ProtexCarrefour": [
		80998,
		9,
		[]
	],
	"./store/campaigns/ProtexCarrefour.js": [
		80998,
		9,
		[]
	],
	"./store/campaigns/ProtexCarrefourJan2022": [
		92055,
		9,
		[]
	],
	"./store/campaigns/ProtexCarrefourJan2022.js": [
		92055,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalCarrefour2022": [
		93737,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalCarrefour2022.js": [
		93737,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalCora2022": [
		48891,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalCora2022.js": [
		48891,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalMega2022": [
		10882,
		9,
		[]
	],
	"./store/campaigns/ProtexCharcoalMega2022.js": [
		10882,
		9,
		[]
	],
	"./store/campaigns/ProtexHealthProtection2023": [
		16185,
		9,
		[]
	],
	"./store/campaigns/ProtexHealthProtection2023.js": [
		16185,
		9,
		[]
	],
	"./store/campaigns/ProtexSummerCarrefour2022": [
		58255,
		9,
		[]
	],
	"./store/campaigns/ProtexSummerCarrefour2022.js": [
		58255,
		9,
		[]
	],
	"./store/campaigns/ProtexSummerRomania": [
		57269,
		9,
		[]
	],
	"./store/campaigns/ProtexSummerRomania.js": [
		57269,
		9,
		[]
	],
	"./store/campaigns/Protexcashback2025": [
		69818,
		9,
		[]
	],
	"./store/campaigns/Protexcashback2025.js": [
		69818,
		9,
		[]
	],
	"./store/campaigns/SpringCleaning2025": [
		16720,
		9,
		[]
	],
	"./store/campaigns/SpringCleaning2025.js": [
		16720,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningCarrefour2022": [
		12418,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningCarrefour2022.js": [
		12418,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningCora2022": [
		81590,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningCora2022.js": [
		81590,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningMega2022": [
		82195,
		9,
		[]
	],
	"./store/campaigns/SpringCleaningMega2022.js": [
		82195,
		9,
		[]
	],
	"./store/campaigns/Springcleaning2024": [
		86567,
		9,
		[]
	],
	"./store/campaigns/Springcleaning2024.js": [
		86567,
		9,
		[]
	],
	"./store/campaigns/SummerExperience2024": [
		51032,
		9,
		[]
	],
	"./store/campaigns/SummerExperience2024.js": [
		51032,
		9,
		[]
	],
	"./store/campaigns/SummerJoy2025": [
		81147,
		9,
		[]
	],
	"./store/campaigns/SummerJoy2025.js": [
		81147,
		9,
		[]
	],
	"./store/campaigns/WomenDay2024": [
		89369,
		9,
		[]
	],
	"./store/campaigns/WomenDay2024.js": [
		89369,
		9,
		[]
	],
	"./store/campaigns/WomenDay2025": [
		19114,
		9,
		[]
	],
	"./store/campaigns/WomenDay2025.js": [
		19114,
		9,
		[]
	],
	"./store/campaigns/WomenDay2026": [
		96375,
		9,
		[]
	],
	"./store/campaigns/WomenDay2026.js": [
		96375,
		9,
		[]
	],
	"./store/colgate": [
		72364,
		9,
		[]
	],
	"./store/colgate.js": [
		72364,
		9,
		[]
	],
	"./store/getters": [
		59769,
		9,
		[]
	],
	"./store/getters.js": [
		59769,
		9,
		[]
	],
	"./store/index": [
		41153,
		9,
		[]
	],
	"./store/index.js": [
		41153,
		9,
		[]
	],
	"./store/mutations": [
		12153,
		9,
		[]
	],
	"./store/mutations.js": [
		12153,
		9,
		[]
	],
	"./store/state": [
		35956,
		9,
		[
			5956
		]
	],
	"./store/state.js": [
		35956,
		9,
		[
			5956
		]
	],
	"./vee-validate": [
		17490,
		9,
		[]
	],
	"./vee-validate.js": [
		17490,
		9,
		[]
	],
	"./views/FileViewer": [
		96875,
		9,
		[
			6875
		]
	],
	"./views/FileViewer.vue": [
		96875,
		9,
		[
			6875
		]
	],
	"./views/GeoLimit": [
		42723,
		9,
		[
			2723
		]
	],
	"./views/GeoLimit.vue": [
		42723,
		9,
		[
			2723
		]
	],
	"./views/Home": [
		41,
		9,
		[
			41
		]
	],
	"./views/Home.vue": [
		41,
		9,
		[
			41
		]
	],
	"./views/Sitedown": [
		59169,
		9,
		[
			9169
		]
	],
	"./views/Sitedown.vue": [
		59169,
		9,
		[
			9169
		]
	],
	"./views/security-page": [
		11192,
		9,
		[
			1192
		]
	],
	"./views/security-page.vue": [
		11192,
		9,
		[
			1192
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[2].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, ids[1] | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;